/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const CropAltIconConfig = {
  name: 'CropAltIcon',
  height: 512,
  width: 512,
  svgPath: 'M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(CropAltIconConfig);
//# sourceMappingURL=crop-alt-icon.js.map